<template>
  <div class="scene">
    <div class="cube" :style="cubeStyle" :class="{ rolling: isRolling }">
      <div v-for="(face, index) in faces" :key="index" :class="['cube-face', face.class]">
        <img :src="`${CDN_URL}/${face.value}.png`" :alt="`Dice face ${face.value}`" class="face-img">
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL_1 } from "@/config";
const offsetX = 15
const offsetY = 20
const rotations = {
  1: { x: 0, y: 0 },
  2: { x: 90, y: 0 },
  3: { x: 0, y: 90 },
  4: { x: 0, y: -90 },
  5: { x: -90, y: 0 },
  6: { x: 180, y: 0 }
};
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      CDN_URL: CDN_URL_1 + '/box_zillionaire',
      isRolling: false,
      currentValue: 1,
      rotateX: offsetX,
      rotateY: offsetY,
      faces: [
        { class: 'front', value: 1 },
        { class: 'back', value: 6 },
        { class: 'right', value: 4 },
        { class: 'left', value: 3 },
        { class: 'top', value: 5 },
        { class: 'bottom', value: 2 }
      ],
    }
  },
  computed: {
    cubeStyle() {
      return {
        transform: `rotateX(${this.rotateX}deg) rotateY(${this.rotateY}deg)`
      }
    }
  },
  methods: {
    rollDice (newValue) {
      if (this.isRolling || this.disabled) return
      this.isRolling = true;
      
      const extraRotations = 3;
      this.rotateX = rotations[newValue].x + extraRotations * 360 + ((rotations[newValue].x < 0 ? -1 : 1) *(offsetX));
      this.rotateY = rotations[newValue].y + extraRotations * 360 + ((rotations[newValue].y < 0 ? -1 : 1) *(offsetY));

      setTimeout(() => {
        this.isRolling = false;
        this.currentValue = newValue;
        this.rotateX = rotations[newValue].x + ((rotations[newValue].x < 0 ? -1 : 1) *(offsetX));
        this.rotateY = rotations[newValue].y + ((rotations[newValue].y < 0 ? -1 : 1) *(offsetY));
        this.$emit('roll', newValue)
      }, 2000);
    }
  }
}
</script>

<style scoped>
.scene {
  width: 36px;
  height: 36px;
  perspective: calc(36px * 6);
  margin: 0 auto;
}

.cube {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  /* transition: transform 0.5s ease-out; */
}

.cube-face {
  position: absolute;
  width: 36px;
  height: 36px;
  background: white;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 20%;
  box-shadow: 
    inset 0 0 5px rgba(0, 0, 0, 0.1),
    0 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.face-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.front  { transform: rotateY(0deg) translateZ(calc(36px / 2)); }
.back   { transform: rotateY(180deg) translateZ(calc(36px / 2)); }
.right  { transform: rotateY(90deg) translateZ(calc(36px / 2)); }
.left   { transform: rotateY(-90deg) translateZ(calc(36px / 2)); }
.top    { transform: rotateX(90deg) translateZ(calc(36px / 2)); }
.bottom { transform: rotateX(-90deg) translateZ(calc(36px / 2)); }

.rolling {
  transition: transform 2s cubic-bezier(0.25, 0.1, 0.25, 1);
}
</style>